new Vue({
    el: "#change-password",
    data: {
        profile: {},
        showPassword: false,
        showNewPassword: false,
        password: "",
        new_password: "",
        new_password_confirmation: "",
        msg_password: "",
        msg_new_password: "",
        msg_new_password_confirmation: "",
        isSubmitting: false,
        rule1Valid: false,
        ruleLowercaseValid: false,
        ruleUppercaseValid: false,
        ruleNumberValid: false,
        passwordChanged: false,
    },
    created: async function () {
        this.get();
    },
    methods: {
        async get() {
            let response = await $getUser;
            this.profile = { ...response.data };
        },
        async post() {
            this.clearErrorMessages();
            this.isSubmitting = true;

            let form = this.getFormData(this.$refs.form);
            form.id = this.profile.id;

            try {
                await axios.put(api_url + "user/user-change-password", form, {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                        "Content-Type": "application/json",
                    }
                });

                this.showToast("Senha alterada com sucesso!", "#6EA204", "#9EC600");
                this.passwordChanged = true;

                setTimeout(() => {
                    const domain = window.location.origin;
                    const profileUrl = `${domain}/perfil`;
                    window.location.href = profileUrl;
                }, 7000);
            } catch (error) {
                this.handleErrors(error.response.data);
            } finally {
                this.isSubmitting = false;
            }
        },
        getFormData(form) {
            return Array.from(form).reduce((acc, field) => {
                if (field.name) acc[field.name] = field.value;
                return acc;
            }, {});
        },
        togglePassword(id) {
            const toggles = ["showPassword", "showNewPassword"];
            if (toggles[id] !== undefined) {
                this[toggles[id]] = !this[toggles[id]];
            }
        },
        showToast(message, bgColor, loadBarBgColor = "") {
            $.toast({
                text: message,
                position: 'bottom-right',
                textColor: 'white',
                bgColor: bgColor,
                loaderBg: loadBarBgColor,
                hideAfter: 6000,
            });
        },
        clearErrorMessages() {
            this.msg_password = "";
            this.msg_new_password = "";
            this.msg_new_password_confirmation = "";
        },
        handleErrors(errors) {
            const errorTypes = ["error", "user_not_found"];

            errorTypes.forEach(type => {
                if (errors[type]) this.showToast(errors[type], "#CE1126", "#E15353");
            });

            Object.entries(errors).forEach(([key, validationErrorMessages]) => {
                validationErrorMessages.forEach(msg => {
                    this[`msg_${key}`] += `* ${msg}<br>`;
                });
            });
        },
        checkPassword() {
            this.rule1Valid = this.new_password.length >= 8;
            this.ruleLowercaseValid = /[a-z]/.test(this.new_password);
            this.ruleUppercaseValid = /[A-Z]/.test(this.new_password);
            this.ruleNumberValid = /[0-9]/.test(this.new_password);
        },
        forgotPassword() {
            localStorage.removeItem('token');
            localStorage.removeItem('user_id');
            localStorage.removeItem('show_message');
            localStorage.setItem('force_password_recovery', null);

            const domain = window.location.origin;
            const profileUrl = `${domain}/acesso`;
            window.location.href = profileUrl;
        },
    }
});
